import axios from 'axios';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export async function callApi(): Promise<Optional<Response>> {
	const url: string = `${SERVICEBASEURL.BACKEND}/Setting`;
	return axios.get(url).toOptionalMapped((x) => x.data);
}

export interface Response {
	calculationSettings: {
		quantityMethod: string;
	};
	currencySettings: {
		primaryCurrency: string;
	};
	ui: {
		languages: string;
		menuBarOrder: string;
	};
	recipeSettings: {
		autoCompleteLanguages: string;
		entryLanguages: string;
	};
}
